export default __webpack_public_path__ + "static/media/MaskGroup202.e9484b4e.png";